import { ILandingPage } from '@/types/landing-page';
import {
  DeleteOutline,
  ExpandMore,
  RefreshOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

type ActionsCellProps = {
  original: ILandingPage;
  onPreview: (id: string) => void;
  onRegenerate: (id: string) => void;
  onPublishToggle: (id: string, isPublished: boolean) => void;
  onDelete: (id: string) => void;
};

export function ActionsCell({
  original,
  onPreview,
  onRegenerate,
  onPublishToggle,
  onDelete,
}: ActionsCellProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex gap-3 justify-between items-center w-full">
      <ButtonGroup
        disableElevation
        variant="contained"
        aria-label="landing page actions"
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => onPreview(original._id!)}
          className="rounded-r-none border-lines"
        >
          Preview
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={handleClick}
          aria-controls={open ? 'landing-page-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          className="rounded-l-none bg-gray-background border-dividers"
        >
          <ExpandMore />
        </Button>
      </ButtonGroup>
      <Menu
        id="landing-page-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'landing-page-actions',
          },
        }}
      >
        <MenuItem
          className="px-3 py-2 border-b last-of-type:border-none"
          onClick={() => {
            onRegenerate(original._id!);
            handleClose();
          }}
        >
          <RefreshOutlined className="mr-2" />
          Regenerate
        </MenuItem>
        <MenuItem
          className="px-3 py-2 border-b last-of-type:border-none"
          onClick={() => {
            onPublishToggle(original._id!, original.isPublished);
            handleClose();
          }}
        >
          {original.isPublished ? (
            <VisibilityOffOutlined className="mr-2" />
          ) : (
            <VisibilityOutlined className="mr-2" />
          )}
          {original.isPublished ? 'Unpublish' : 'Publish'}
        </MenuItem>
        <MenuItem
          className="px-3 py-2 border-b last-of-type:border-none"
          onClick={() => {
            onDelete(original._id!);
            handleClose();
          }}
        >
          <DeleteOutline className="mr-2" />
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
}
